import styled from 'styled-components';
import AuthPageSection from './_AuthPageSection';
import { BREAKPOINTS } from '../styles';

const ScreenSetsContainer = styled(AuthPageSection)<{ centerContents: boolean }>`
  padding: 8px;
  width: calc(100% - 16px);
  align-items: ${props => (props.centerContents ? 'center' : 'unset')};

  .gigya-screen-caption {
    display: none;
  }

  .gigya-screen {
    max-width: 100%;
    margin: auto;
  }

  ${BREAKPOINTS.MEDIUM} {
    .gigya-screen {
      margin: 0;
      padding: 36px 25px !important;
    }
  }

  ${BREAKPOINTS.XLARGE} {
    .gigya-screen {
      max-width: 500px;
    }
  }
`;

export default ScreenSetsContainer;
